import { FC, Fragment, memo, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { faqData } from "common/constants/extra-service-info";

type Props = {};

const Component: FC<Props> = () => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Fragment>
      <Box mt={10} mb={10}>
        <Typography
          fontSize={{ xs: "32px", lg: "38px" }}
          ml={-0.5}
          mb={3}
          fontWeight={900}
        >
          FAQ
        </Typography>
        {faqData.map((faq, index) => (
          <Accordion
            key={index}
            expanded={expanded === `panel${index}`}
            onChange={handleChange(`panel${index}`)}
            sx={{
              mb: 2,
              p: 1.5,
              backgroundColor:
                expanded === `panel${index}` ? "white" : "#EBEFF4",
              border: "1px solid #7D879C",
              "&:before": {
                display: "none", // Removes default shadow line
              },
            }}
          >
            <AccordionSummary
              expandIcon={
                expanded === `panel${index}` ? (
                  <RemoveCircleIcon color="secondary" />
                ) : (
                  <AddCircleIcon color="secondary" />
                )
              }
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
            >
              <Typography
                sx={{ fontSize: { xs: "16px", lg: "18px" } }}
                fontWeight={"bold"}
              >
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 2 }}>
              <Typography sx={{ fontSize: { xs: "16px", lg: "20px" } }}>
                {faq.content}
              </Typography>
              <Box>
                {faq?.bullets?.map((bullet, index) => (
                  <List
                    key={index}
                    sx={{ listStyleType: "disc", ml: { xs: 3, lg: 5 } }}
                  >
                    <ListItem sx={{ display: "list-item", padding: 0, mb: -2 }}>
                      <Typography sx={{ fontSize: { xs: "16px", lg: "20px" } }}>
                        {bullet}
                      </Typography>
                    </ListItem>
                  </List>
                ))}
              </Box>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Fragment>
  );
};

export const ExtraServiceFaq = memo(Component);
